import { Box, Link, Typography } from "@mui/material";

export const PRIVACY_URL = "https://cloud.pinehood.tech/privacy/";
export const TERMS_URL = "https://cloud.pinehood.tech/terms/";

export function LegalFooter() {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        mt: "auto",
        borderTop: 1,
        borderColor: "divider",
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="caption" color="text.secondary">
        © {new Date().getFullYear()} Pinehood
      </Typography>
      <Link
        href={TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="caption"
        color="text.secondary"
      >
        Uvjeti korištenja
      </Link>
      <Link
        href={PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="caption"
        color="text.secondary"
      >
        Pravila privatnosti
      </Link>
    </Box>
  );
}
